import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import permission from './modules/permission'
import errorLog from './modules/errorLog'
import tagsView from './modules/tagsView'
import webSocket from './modules/webSocket'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    permission,
    errorLog,
    tagsView,
    webSocket
  },
  getters
})

export default store
